import api from "../service";
import { store } from "store/configureStore";
import { hotToast, middlewareResponse } from "utils";

export const getParamsSegmentation = async (idUser: number, idView: number) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `Segmentacion/GetParametrosSegmentacion?idUsuario=${idUser}&idVista=${idView}`
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const setParamsSegmentation = async (
  idUser: number,
  idView: number,
  segmentacionValores: any
) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `Segmentacion/SetParametrosSegmentacion?idUsuario=${idUser}&idVista=${idView}`,
    segmentacionValores
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    hotToast("Los datos se guardaron correctamente", "SUCCESS");
    return data.data;
  }
  return null;
};
